import { fetchWrapperPublic } from "helpers/fetch-wrapper";
import { API_BASE_URL } from "helpers/constants";

export class CategoryRequests {
    static async getCategories(): Promise<Response> {
        return await fetchWrapperPublic.get(
            `${API_BASE_URL}/business/categories`
        );
    }

    static async createCategory(data: { name: string }): Promise<Response> {
        return await fetchWrapperPublic.post(
            `${API_BASE_URL}/business/categories`, data
        );
    }
}
